import React, { useState } from 'react';
import { PersonalData } from './PersonalData';
import { Notifications } from './Notifications';
import { Requests } from './Historic/Resquests';
import { TabNav } from '../../components/TabNav';
import { Tab } from '../../components/Tab';
import { Menu } from '../../components/Menu';
import { menuListItems } from '../../assets/menu/menuList';
import { BaseRoutes } from 'routes/BaseRoutes';

const tabs = ['Dados pessoais', 'Notificações', 'Histórico'];

export const CustomerDetails: React.FC = () => {
  const [selected, setSelected] = useState(tabs[0]);

  return (
    <Menu links={menuListItems}>
      <TabNav tabs={tabs} selected={selected} setSelected={setSelected} backPath={BaseRoutes.home}>

        <Tab isSelected={selected} tabName="Dados pessoais">
          <PersonalData />
        </Tab>

        <Tab isSelected={selected} tabName="Notificações">
          <Notifications />
        </Tab>

        <Tab isSelected={selected} tabName="Histórico">
          <Requests />
        </Tab>

      </TabNav>
    </Menu>
  )
}